// export const SET_SECTIONS = (state, payload = []) => {
//     state.section.items = payload;
// };

export const SET_UNASSIGNED_GUARDIAN = (state, payload) => {
    state.guardian.unassigned = payload;
};